import { useState, useCallback } from 'react';
import { Props } from './types';

const useAskModal = ({ onPublish, onPublishEnd, onDiscard }: Props) => {
  const [modalIsOpen, setModal] = useState<boolean>(false);
  const [isPublishing, setIsPublishing] = useState<boolean>(false);

  const openModal = useCallback(() => {
    setModal(true);
  }, [setModal]);

  const closeModal = useCallback(() => {
    setModal(false);
  }, [setModal]);

  const handleDiscard = useCallback(() => {
    setModal(false);
    onDiscard();
  }, [setModal, onDiscard]);

  const handleConfirm = useCallback(async () => {
    setIsPublishing(true);
    try {
      await onPublish();
      closeModal();
      onPublishEnd();
    } catch (error) {
      closeModal();
    } finally {
      setIsPublishing(false);
    }
  }, [onPublish, closeModal, setIsPublishing, onPublishEnd]);

  return {
    modalIsOpen,
    isPublishing,
    openModal,
    handleCancel: closeModal,
    handleDiscard,
    handleConfirm,
  };
};

export default useAskModal;

// TODO: TFR-47 move hooks and effects into proper repository (hooks or utils)
